module.exports = __webpack_public_path__ + "img/source1_4.d0956bbd.png";